

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Report() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchReports = async () => {
      try {
        const res = await fetch("https://ppmn.net/dash/api/Get/CategoryArticles/report-news");
        const json = await res.json();
        const result = Array.isArray(json?.data) ? json.data : [];
        setData(result);
      } catch (err) {
        console.error("فشل في جلب التقارير:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchReports();
  }, []);

  if (loading) {
    return <div className="text-center py-5">جاري تحميل التقارير...</div>;
  }

  if (data.length === 0) {
    return <div className="text-center py-5">لا توجد تقارير متاحة حالياً.</div>;
  }

  return (
    <div className="container my-5">
      <div className="section-header mb-4">التقارير</div>
      <div className="row">
        {data.map((item) => (
          <div className="col-xl-3 col-lg-4 col-md-6 mb-4" key={item.article_id}>
            <div
              className="card card-custom h-100 d-flex flex-column justify-content-between"
              onClick={() =>
                navigate(`/News/report-news/${item.article_id}/${item.article_slug}`)
              }
              style={{ cursor: "pointer" }}
            >
              <img
                src={item.article_title_image}
                alt={item.article_title}
                className="card-img-top"
                style={{ height: "180px", objectFit: "cover" }}
              />
              <div className="card-body p-3 flex-grow-1">
                <h6 className="card-title mb-0">{item.article_title}</h6>
              </div>
              <div className="card-footer d-flex justify-content-between align-items-center px-3 py-2 bg-white border-top mt-auto">
                <small className="text-muted">{item.article_published_before}</small>
                <div className="d-flex align-items-center">
                  <img
                    src={item.user_image}
                    alt={item.user_name}
                    style={{
                      width: "22px",
                      height: "22px",
                      borderRadius: "50%",
                      objectFit: "cover",
                      marginLeft: "6px",
                    }}
                  />
                  <small className="text-muted">{item.user_name}</small>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
